<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        01.16
        <br />2019
      </span>
      <span class="tiel">中国公益节2018年度公益项目奖开展，美菜网SOS拔得头筹</span>
    </div>
    <div class="mat-content">
      <div class="tet-js">
        前不久，一年一度的中国公益节于北京展开，该次公益节本着“年度致敬，向公益践行者致敬”的宗旨展开，并且吸引了很多企业以及个人前来参加并观看。在此次颁奖典礼上，美菜网凭借“美菜SOS精准扶贫全国采购计划”在300多个企业当中拔得头筹，荣获“2018年度公益项目奖”。
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/b013_1.jpeg" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">美菜SOS荣获中国公益节2018年度公益项目奖</div>

      <div class="tet-js">
        设立于2011年的公益节，是国内首个由大众媒体联袂发起的以“公益”命名的节日。据悉，本届公益节评选为纯公益性活动，共收到了955家企业、526名人物代表、258家公益机构、311个公益项目报名参评。由评审委员会基于示范性、持续性、创新性、诚信度等指标，进行可量化数据比对，最终评选出“公益集体奖”、“公益人物奖”、“公益项目奖”、“扶贫贡献奖”、“企业责任奖”等奖项。
        <br />
        <br />凭借“美菜SOS精准扶贫全国采购计划”，美菜网在近千家企业的300余个公益项目中脱颖而出，获颁第八届中国公益节“2018年度公益项目奖”。
        <br />
        <br />“让天下的餐厅没有难做的生意，为8亿农民谋幸福，让13亿中国人吃上放心菜。”美菜网企业社会责任总监孙乾上台领奖并作主题发言介绍说，美菜网作为中国餐饮供应链杰出服务商，积极贯彻落实国家乡村振兴战略，以其独有的商业模式通过自建仓储、物流、配送，创新升级农产品供应链，砍掉所有的中间环节，一端链接田间地头，一端链接市场和城市消费。同时利用其大数据系统，将市场需求准确反馈给农民，避免了货不对市，有望从根源上解决销路问题。
        <br />
        <br />美菜网推出的“美菜SOS精准扶贫全国采购计划”，旨在紧急救助滞销农产品，帮助其拓宽销售渠道，让陷入绝望的滞销菜农重燃起希望。通过建立农产品应急救助中心，积极为贫困地区、滞销地区分销农产品，进行渠道扶贫，助力贫困地区农产品走出来，扶贫到穷根上。
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/b013_2.jpeg" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">美菜SOS荣获中国公益节2018年度公益项目奖</div>

      <div class="tet-js">
        自2017年以来，“美菜SOS精准扶贫全国采购计划”足迹遍及全国22个地区，采购滞销农产品总量2653.4万斤。其中，仅环京津34个贫困地区的农产品采购总量就达到8306.2万斤。
        <br />
        <br />美菜网将社会责任担到肩上，为扶贫事业带来了一阵清风，也为互联网扶贫开了一个好头，这样不仅从源头上解决了农民销货难的情况，也为农产品的销售开启了绿色通道，让春天的暖流也注入了农村。
        <br />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
